import React from 'react';
import '../animations.css';

const Header = () => {
  return (
    <header>
      <h1>Happy thoughts</h1>
    </header>
  )
};

export default Header;